<mat-form-field>
  <mat-label>E-post</mat-label>
  <input #input="ngModel" [(ngModel)]="model" email matInput
         maxlength="75"
         type="email">

  @if (input.errors?.['email']) {
    <mat-error>Ogiltig e-postadress</mat-error>
  } @else if (input.errors?.['required']) {
    <mat-error>Vänligen kontrollera fältet</mat-error>
  }

  @if (input.errors && input.touched) {
    <mat-icon matIconSuffix aria-hidden="true">
      priority_high
    </mat-icon>
  }
</mat-form-field>
